import DynamicMenuItems from '@my-pages/features/auth/components/menu/DynamicMenuItems.tsx';
import StaticMenuItems from '@my-pages/features/auth/components/menu/StaticMenuItems.tsx';
import LogoutMenuItem from '@my-pages/features/auth/components/menu/LogoutMenuItem.tsx';
import BackDrop from '@my-pages/features/auth/components/menu/BackDrop.tsx';

export const Menu = () => {
    return (
        <aside className='nav-sidebar'>
            <nav className='nav-main'>
                <DynamicMenuItems />
                <div className='nav-main-divider'></div>
                <StaticMenuItems />

                <div className='nav-main-divider'></div>
                <LogoutMenuItem />
            </nav>
            <BackDrop />
        </aside>
    );
};
